import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Gift } from "lucide-react";
import { Button } from "./ui/button";

// Super-Admin: scelta del circuito «vetrina» le cui grafiche gift card compaiono sulla landing della piattaforma
export default function LandingShowcaseCard() {
  const [data, setData] = useState(null);
  const [slug, setSlug] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/platform/landing-settings").then(({ data }) => { setData(data); setSlug(data.showcase_tenant || ""); }).catch(() => {}); }, []);
  if (!data) return null;
  const save = async () => {
    setBusy(true);
    try { await api.put("/platform/landing-settings", { showcase_tenant: slug }); toast.success(slug ? "Circuito vetrina salvato" : "La landing usa le grafiche di esempio"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const sel = data.tenants.find((t) => t.slug === slug);
  return (
    <div className="card-elev p-4 space-y-3" data-testid="landing-showcase-card">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1.5"><Gift className="h-3.5 w-3.5" /> Landing piattaforma · grafiche gift card</div>
      <p className="text-xs text-zinc-400">Le miniature della sezione «Gift Card» su nouvellefidelity.it mostrano le immagini a tema caricate dal circuito scelto qui (Admin → Gift Card → Grafiche). Senza scelta, o se il circuito non ha immagini, restano le 6 grafiche di esempio.</p>
      <div className="flex flex-wrap items-center gap-2">
        <select value={slug} onChange={(e) => setSlug(e.target.value)} className="bg-zinc-950 border border-zinc-800 rounded-md h-9 px-2 text-sm text-zinc-100" data-testid="landing-showcase-select">
          <option value="">Grafiche di esempio (predefinite)</option>
          {data.tenants.map((t) => <option key={t.slug} value={t.slug}>{t.name} · {t.with_image}/{t.themes} con immagine</option>)}
        </select>
        <Button size="sm" onClick={save} disabled={busy} className="bg-amber-500 hover:bg-amber-400 text-zinc-950" data-testid="landing-showcase-save">Salva</Button>
        {sel && sel.with_image === 0 && <span className="text-xs text-amber-300" data-testid="landing-showcase-warning">Questo circuito non ha ancora immagini sui temi: la landing userà le grafiche di esempio.</span>}
      </div>
    </div>
  );
}
